import React from "react";
import ReactDOM from "react-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper"; // Import Navigation module
import "swiper/css";
import "swiper/css/navigation"; // Import Swiper navigation styles
import "./imageModal.scss";

function ImageModal({ images, initialIndex, onClose }) {
    if (!images || images.length === 0) return null;

    return ReactDOM.createPortal(
        <div className="Modal__Container" onClick={onClose}>
            <div className="Modal__Content" onClick={(e) => e.stopPropagation()}>
                {/* Close Button */}
                <button className="Modal__CloseButton" onClick={onClose} />

                {/* Swiper */}
                <Swiper
                    modules={[Navigation]} // Use Swiper's Navigation module
                    navigation={{
                        prevEl: ".Modal__Arrow--left", 
                        nextEl: ".Modal__Arrow--right", 
                    }}
                    initialSlide={initialIndex} // Set the starting slide
                    className="Modal__Swiper"
                >
                    {images.map((item, index) => (
                        <SwiperSlide key={index} className="Modal__Slide">
                            {item.isVideo ? (
                                <video
                                    controls
                                    autoPlay={index === initialIndex}
                                    className="Modal__Video"
                                >
                                    <source src={item.url} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            ) : (
                                <img
                                    src={item.url}
                                    alt={item.title}
                                    className="Modal__Image"
                                />
                            )}
                            <p className="Modal__Description">{item.title}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Left Arrow */}
                <button className="Modal__Arrow Modal__Arrow--left">
                    &#8249; {/* Left arrow */}
                </button>

                {/* Right Arrow */}
                <button className="Modal__Arrow Modal__Arrow--right">
                    &#8250; {/* Right arrow */}
                </button>
            </div>
        </div>,
        document.body
    );
}

export default ImageModal;
